<template>
    <span>{{currentStr}}</span>
</template>
<style lang="scss">

</style>
<script>
    export default {
        data(){
            return {
                currentStr:''
            }
        },
        props:{
            order:{type:Object},
        },
        computed:{

        },
        events:{

        },
        created(){
            let getStr = (groupStateName,groupCloseTime,isGroupPurchase)=> {
                if(!isGroupPurchase){
                    this.currentStr = '';
                }else if(groupCloseTime === undefined || groupCloseTime === null || isNaN(groupCloseTime)){
                    this.currentStr = groupStateName;
                }else if(groupCloseTime <= 0){
                    this.currentStr = '拼团失败';
                }else{
                    let h ,
                        m ,
                        s ;
                    let hh = 60 * 60 * 1000,
                        mm = 60 * 1000,
                        ss = 1000;
                    h = String(~~(groupCloseTime/hh));
                    m = String(~~((groupCloseTime - h * hh)/mm));
                    s = String(~~((groupCloseTime - h * hh - m * mm)/ss));

                    h.length === 1 && (h = `0${h}`);
                    m.length === 1 && (m = `0${m}`);
                    s.length === 1 && (s = `0${s}`);
                    let str = `${h}:${m}:${s}`;
                    this.currentStr = groupStateName + '，' + str + '后结束';
                    if(groupCloseTime && groupCloseTime > 0){
                        setTimeout(()=>{
                            getStr(groupStateName,groupCloseTime - 1000,isGroupPurchase)
                        },1000);
                    }
                }
            };

            getStr(this.order.groupStateName,this.order.groupCloseTime - this.order.serverTime,this.order.fixedTags[9] === "6");
            //1-订单创建中，2-待支付，3-支付完成，4-支付失败
//            if(this.order.groupPurchaseOder && this.order.groupPurchaseOder.orderState !== 3){
//
//            }
        },
        methods:{

        }
    }
</script>